"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const ImageRoot = exports.ImageRoot = (0, _mui.styled)('img', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  lowerImageOpacity
}) => ({
  height: '100%',
  left: '50%',
  maxHeight: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
  opacity: lowerImageOpacity ? 0.2 : 1,
  overflow: 'hidden',
  position: 'absolute',
  top: '50%',
  transition: 'filter 400ms, opacity 400ms, transform 500ms !important',
  width: '100%',
  transform: 'translate(-50%, -50%) scale(1)'
}));
//# sourceMappingURL=styles.js.map